"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainflexCategorySchema = void 0;
const zod_1 = require("zod");
exports.ChainflexCategorySchema = zod_1.z.enum(['ControlCables', 'DataCables', 'MotorCables', 'ServoCables', 'PneumaticHoses', 'CoaxCables', 'FibreOpticCables', 'MeasuringSystemCables', 'BusCables', 'RobotCables', 'SpecialCables', 'HydraulicCables', 'HybridCables', 'PullWires']);
exports.default = exports.ChainflexCategorySchema;
//# sourceMappingURL=ChainflexCategorySchema.js.map